import styled from 'styled-components';
import { ANTD_GRAY } from '../../constants';

export default styled.div`
    z-index: 1;
    padding: 8px;
    display: flex;
    flex: 0 0 auto;
    min-height: 46px;
    position: relative;
    background-color: #ffffff;
    justify-content: space-between;
    border-bottom: 1px solid ${ANTD_GRAY[4.5]};

    @media (max-width: 991px) {
        gap: 8px;
        height: auto;
        flex-wrap: wrap;
    }
`;
